import React from 'react'

const VesselSearchDialogContext = React.createContext()

export default VesselSearchDialogContext
